import { render, staticRenderFns } from "./ChargeExtraParametersInputWidget.vue?vue&type=template&id=50601f7c&scoped=true"
import script from "./ChargeExtraParametersInputWidget.vue?vue&type=script&lang=js"
export * from "./ChargeExtraParametersInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50601f7c",
  null
  
)

export default component.exports